import React from 'react';
import NutritionalAnalysisWorkspace, {
  type NutritionalAnalysisWorkspaceProps,
} from './nutritionalAnalysis/NutritionalAnalysisWorkspace';

export type NutritionalAnalysisPageProps = Omit<NutritionalAnalysisWorkspaceProps, 'planMode'> & {
  planMode?: 'manual';
};

const NutritionalAnalysisPage: React.FC<NutritionalAnalysisPageProps> = ({ planMode: _planMode, ...props }) => (
  <NutritionalAnalysisWorkspace {...props} planMode="manual" />
);

export default NutritionalAnalysisPage;
